<template>
  <div :style="containerStyle">
    <div :style="separatorStyle" />
    <div :style="errorMessageStyle">
      {{ errorMessage }}
    </div>
    <div>
      <SearchExpertBoxPopoverRow iconContent="add"
                                 :input="input"
                                 :suggestion="input"
                                 :text="hideText ? '' : 'by skill'"
                                 @click="$emit('add-tag', input)"/>
    </div>
    <div v-for="(suggestion, index) in suggestionLabels" :key="index">
      <SearchExpertBoxPopoverRow iconContent="add"
                                 :input="input"
                                 :suggestion="suggestion"
                                 :useTag="true"
                                 :text="hideText ? '' : 'by skill'"
                                 @click="$emit('add-tag', suggestion)"/>
    </div>
    <div v-if="showSearchByName">
      <SearchExpertBoxPopoverRow iconContent="search"
                                 :text="hideText ? '' : 'by name'"
                                 :input="input"
                                 :suggestion="input"
                                 @click="$emit('search-by-name', input)"/>
    </div>
  </div>
</template>

<script>
  import SearchExpertBoxPopoverRow from '@modules/search-box/search-expert-box-popover-row'
  import IconPrimary from '@modules/icon/icon-primary'
  import { FontStyle } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SearchExpertBoxPopover',
    components: {
      SearchExpertBoxPopoverRow,
    },
    props: {
      errorMessage: { type: String, required: false, default: '' },
      hideText: { type: Boolean, required: false, default: false },
      input: { type: String, required: true },
      suggestions: { type: Array, required: true },
      showSearchByName: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        containerStyle: {
          borderRadius: '0 0 8px 8px',
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          padding: '0 0 8px 0',
          ...this.$attrs,
        },
        errorMessageStyle: {
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.sm,
          padding: '0 0 0 16px',
        },
        separatorStyle: {
          margin: '0 16px 10px 16px',
        },

      };
    },
    created: function () {
      this.containerStyle = {
        ...this.containerStyle,
        backgroundColor: this.color.light1(),
        ...this.$attrs,
      };

      this.errorMessageStyle = {
        ...this.errorMessageStyle,
        color: this.color.warning1(),
      };

      this.separatorStyle = {
        ...this.separatorStyle,
        border: `solid ${this.color.dark5()}`,
        borderWidth: '1px 0 0 0',
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      suggestionLabels: function () {
        return this.suggestions.map(elem => elem.display);
      },
    },
  };
</script>
